const MATTER_PATH = /^\/matters\/[^/]+$/;

/**
 * The key that remounts a page's subtree (and clears its error boundary) when
 * the path changes: the pathname, so every page starts clean on navigation.
 *
 * Every `/matters/:matterId` path shares one key. The matter hub is built to
 * stay mounted when you switch matters (its reads hold the previous matter's
 * answer, and the switcher keeps focus), which a remount would defeat. A crash
 * on one matter still clears on the next navigation through the boundary's
 * `resetKeys`.
 */
export function routeBoundaryKey(pathname: string): string {
  return MATTER_PATH.test(pathname) ? '/matters/:matterId' : pathname;
}
